<template>
  <b-dropdown
    class="agency-picker border"
    v-indicator="{ show: showSelectAgency, rounded: true }"
    :class="{ dark: isDarkMode }"
    :variant="isDarkMode ? 'dark' : 'light'"
  >
    <template #button-content>
      <div id="agency-picker--content" class="agency-picker--content px-1">
        {{ currentAgencyLabel }}
      </div>
    </template>
    <b-dropdown-header>-- Select Agency --</b-dropdown-header>
    <b-dropdown-item
      v-for="agency in currentUser.agencies"
      :key="agency.agency_id"
      @click="handleClickAgencyPickerItem(agency.agency_id)"
    >
      {{ agency.agency_name }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
/* eslint-disable */
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  name: "AgencyPicker",
  computed: {
    ...mapState({
      currentUser: (state) => state.user.user,
      currentToken: (state) => state.user.token,
      sessionId: (state) => state.user.session,
      currentAgency: (state) => state.agency.agency
    }),
    ...mapGetters("agency", ["currentAgencyId"]),
    ...mapGetters("user", ["isDarkMode"]),
    currentAgencyLabel() {
      if (this.currentAgency)
        return this.currentAgency ? this.currentAgency.agency_name : "Select Agency";

      return "Select Agency";
    },
    setAgencyAvailability() {
      return !!this.sessionId && !!this.currentUser;
    },
    showSelectAgency() {
      return !this.$auth.isloading &&
        this.$auth.isAuthenticated &&
        this.currentUser &&
        this.currentUser.agencies &&
        this.currentUser.agencies.length > 1 &&
        !this.currentUser.default_agency &&
        !this.currentAgency;
    }
  },
  data() {
    return {
      selectedAgency: null
    };
  },
  methods: {
    ...mapActions("agency", ["bindAgencySession"]),
    handleClickAgencyPickerItem(agencyId) {
      this.$store.commit("persist/clearTableSettings");
      this.setAgency(agencyId);
    },
    async setAgency(agencyId) {
      try {
        this.selectedAgency = agencyId;

        let customTenantUrl = '';
        await this.$ConveyApi.agenciesApi.getAgency({ agencyId: this.selectedAgency })
          .then(res => {
            const { settings } = res.data.data;
            if (settings['agencyTenantUrl'] !== 'null') {
              customTenantUrl = settings['agencyTenantUrl']
            }
          }).catch(err => {
            console.log(err)
          });
        if (customTenantUrl && ![window.location.host, window.location.origin].includes(customTenantUrl)) {
          const rsosToken = this.$cookie.get("x-rsos-token");
          window.location = `${customTenantUrl}?agency_id=${this.selectedAgency}${rsosToken ? `rsos_token=${rsosToken}` : ''}`;
          return;
        }

        this.bindAgencySession({ agencyId: this.selectedAgency, sessionId: this.sessionId })
          .then(() => {
            this.$router.push({ path: "/" }).catch(() => {});
          })
          .catch(err => {
            if (err.message) {
              console.log(err.message);
            }
          });
      } catch(err) {
        console.log('[AgencyPicker:setAgency] ERROR:', err);
      }
    }
  },
};
</script>

<style lang="scss">
.agency-picker {
  border-color: #455a64 !important;
  border-radius: 1.5rem;
  >button {
    display: flex;
    align-items: center;
    width: 100%;
    border-radius: 1.5rem;
  }

  .dropdown-menu {
    min-width: 300px;
    max-width: 80vw;
    max-height: 240px;
    overflow-y: auto;

    .dropdown-item {
      white-space: wrap;
    }
  }
  &--content {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>